export default "__VITE_ASSET__e920deb1__"